require('./RARiskInput.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ components
const FormattedTextWithComponents = require('components/FormattedTextWithComponents/FormattedTextWithComponents');
const RAInput = require('../../commons/RAInput/RAInput');
const RAOneLineSymbolAmount = require('components/RAComponents/commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
// @ constants
const { EURO_SYMBOL } = require('constants/RAConstants');

class RARiskInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleUpdateResultValue = this.handleUpdateResultValue.bind(this);
    }

    handleUpdateResultValue(value) {
        this.props.updateVolatilityInputValue(value);
    }

    buildInputComponent() {
        const { amount, disabled, showBlurZero } = this.props;

        return (
            <div className="ra-risk-input__container__label2__input">
                <RAInput
                    amount={amount}
                    onChange={this.handleUpdateResultValue}
                    min={0}
                    max={5000000}
                    showBlurZero={showBlurZero}
                    disabled={disabled}
                />
            </div>
        );
    }

    render() {
        const { amount, sliderValue, disabled } = this.props;
        const injectedCalculatedValue = (amount * sliderValue) / 100;
        const raInputComponent = this.buildInputComponent();
        const raAmountComponent = (
            <RAOneLineSymbolAmount
                className="ra-risk-input__amount"
                amountObject={{ amount: injectedCalculatedValue, currency: EURO_SYMBOL }}
            />
        );
        const classLabel1 = classNames('ra-risk-input__container__label1', {
            'ra-risk-input__container__label1--is-disabled': !!disabled,
        });
        const classLabel2 = classNames('ra-risk-input__container__label2', {
            'ra-risk-input__container__label2--is-disabled': !!disabled,
        });

        return (
            <div className="ra-risk-input">
                <div className="ra-risk-input__container">
                    <div className={classLabel1}>
                        <FormattedTextWithComponents
                            value="volatilityInput-inputLabel"
                            injectedComponents={[raInputComponent]}
                        />
                        <div className="ra-risk-input__container__label1__symbol">{EURO_SYMBOL}</div>
                    </div>
                    <div className={classLabel2}>
                        <FormattedTextWithComponents
                            value="volatilityInput-amountLabel"
                            injectedComponents={[raAmountComponent]}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RARiskInput.propTypes = {
    amount: PropTypes.number,
    disabled: PropTypes.bool,
    showBlurZero: PropTypes.bool,
    sliderValue: PropTypes.number,
    updateVolatilityInputValue: PropTypes.func,
};

module.exports = RARiskInput;
